module.exports = __webpack_public_path__ + "static/media/1.fd7735a6.svg";